/* eslint-disable */
import { PluginContainerData, Media, PlaybackOptions } from './common';

export interface VideoData {
  /** Styling for the video's container. */
  containerData?: PluginContainerData;
  /** Video details. */
  video?: Media;
  /** Video thumbnail details. */
  thumbnail?: Media;
  /** Sets whether the video's download button is disabled. Defaults to `false`. */
  disableDownload?: boolean;
  /** Video title. */
  title?: string;
  /** Video options. */
  options?: PlaybackOptions;
}

const baseVideoData: object = {};

export const VideoData = {
  fromJSON(object: any): VideoData {
    const message = { ...baseVideoData } as VideoData;
    message.containerData =
      object.containerData !== undefined && object.containerData !== null
        ? PluginContainerData.fromJSON(object.containerData)
        : undefined;
    message.video =
      object.video !== undefined && object.video !== null
        ? Media.fromJSON(object.video)
        : undefined;
    message.thumbnail =
      object.thumbnail !== undefined && object.thumbnail !== null
        ? Media.fromJSON(object.thumbnail)
        : undefined;
    message.disableDownload =
      object.disableDownload !== undefined && object.disableDownload !== null
        ? Boolean(object.disableDownload)
        : undefined;
    message.title =
      object.title !== undefined && object.title !== null ? String(object.title) : undefined;
    message.options =
      object.options !== undefined && object.options !== null
        ? PlaybackOptions.fromJSON(object.options)
        : undefined;
    return message;
  },

  toJSON(message: VideoData): unknown {
    const obj: any = {};
    message.containerData !== undefined &&
      (obj.containerData = message.containerData
        ? PluginContainerData.toJSON(message.containerData)
        : undefined);
    message.video !== undefined &&
      (obj.video = message.video ? Media.toJSON(message.video) : undefined);
    message.thumbnail !== undefined &&
      (obj.thumbnail = message.thumbnail ? Media.toJSON(message.thumbnail) : undefined);
    message.disableDownload !== undefined && (obj.disableDownload = message.disableDownload);
    message.title !== undefined && (obj.title = message.title);
    message.options !== undefined &&
      (obj.options = message.options ? PlaybackOptions.toJSON(message.options) : undefined);
    return obj;
  },
};
